<template>
  <div class="container-fluid my-3 target" style="min-height:50vh">
    <div class="row">
      <div class="col-12">
        <div class="d-flex menu">
          <div class="title d-sm-flex pointer active">
            <div class="my-auto">
              {{ copy.schoolPointsOverview }}
            </div>
          </div>
          <div @click="goTitlePage('AiGroupSummary')" class="title  d-sm-flex pointer">
            <div class="my-auto">
              {{ copy.classPointsOverview }}
            </div>
          </div>
          <div @click="goTitlePage('AiModify')" class="title  d-sm-flex pointer">
            <div class="my-auto">
              {{ copy.pointsAdjustment }}
            </div>
          </div>
          <div @click="goTitlePage('AiPersonalSummary')" class="title  d-sm-flex pointer">
            <div class="my-auto">
              {{ copy.personalUsageRecords }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 mt-4" style="min-height:40vh">
        <h4 style="text-align:left">{{ copy.pointsStatusStatistics }}</h4>
        <table class="rwd-table mt-3" v-if="AiSummaryDetail">
          <tbody>
            <tr>
              <th>{{ copy.totalPoints }}</th>
              <th>{{ copy.unallocatedPoints }}</th>
              <th>{{ copy.allocatedPoints }}</th>
              <th>{{ copy.usedPoints }}</th>
              <th>{{ copy.allocatedUnusedPoints }}</th>
            </tr>
            <tr>
              <td :data-th="copy.totalPoints">
                {{Math.floor(AiSummaryDetail.total)}}
              </td>
              <td :data-th="copy.unallocatedPoints">
                {{Math.floor(AiSummaryDetail.unallocated)}}
              </td>
              <td :data-th="copy.allocatedPoints">
                {{Math.floor(AiSummaryDetail.allocation)}}
              </td>
              <td :data-th="copy.usedPoints">
                {{Math.floor(AiSummaryDetail.used)}}
              </td>
              <td :data-th="copy.allocatedUnusedPoints">
                {{Math.floor(AiSummaryDetail.unused)}}
              </td>
            </tr>
          </tbody>
        </table>
        <br/>
        <h4 style="text-align:left">{{ copy.pointsAllocationRecords }}</h4>
        <table class="rwd-table mt-3">
          <tbody>
            <tr>
              <th>{{ copy.time }}</th>
              <th>{{ copy.change }}</th>
              <th>{{ copy.quantity }}</th>
              <th>{{ copy.remainingPoints }}</th>
              <th>{{ copy.note }}</th>
            </tr>
            <tr v-for="(item, index) in AiSummary" :key="index">
              <td :data-th="copy.time">
                {{moment(item.updated_at).format("YYYY-MM-DD HH:mm")}}
              </td>
              <td :data-th="copy.change">
                {{ item.type === 'inc' ? copy.increase : copy.decrease }}
              </td>
              <td :data-th="copy.quantity">
                {{Math.floor(item.value)}}
              </td>
              <td :data-th="copy.remainingPoints">
                {{ Math.floor(item.to)}}
              </td>
              <td :data-th="copy.note">
                {{item.notes}}
              </td>
            </tr>
          </tbody>
        </table>
        <div>
          <pagination v-if="pageCount>1" class="m-auto pt-4" :current="pageIndex" :total="pageCount" v-on:page="toPage"/>
        </div>
      </div>
		</div>
  </div>
</template>
<script>
// @ is an alias to /src
import Pagination from '@/components/Pagination.vue'
import 'vue2-datepicker/index.css'
import api from '../../../store/api'
export default {
  name: 'Ai-Summary',
  data () {
    return {
      AiSummary: null,
      AiSummaryDetail: null,
      pageCount: 10,
      pageIndex: 1
    }
  },
  computed: {
    currentLocale () {
      return this.$i18n ? this.$i18n.locale : 'tw'
    },
    copy () {
      const copy = {
        tw: {
          schoolPointsOverview: '\u5168\u6821\u9ede\u6578\u7e3d\u89bd',
          classPointsOverview: '\u73ed\u7d1a\u9ede\u6578\u7e3d\u89bd',
          pointsAdjustment: '\u9ede\u6578\u8abf\u6574',
          personalUsageRecords: '\u500b\u4eba\u4f7f\u7528\u7d00\u9304',
          pointsStatusStatistics: '\u9ede\u6578\u73fe\u6cc1\u7d71\u8a08',
          totalPoints: '\u7e3d\u9ede\u6578',
          unallocatedPoints: '\u672a\u5206\u914d\u9ede\u6578',
          allocatedPoints: '\u5df2\u5206\u914d\u9ede\u6578',
          usedPoints: '\u5df2\u4f7f\u7528\u9ede\u6578',
          allocatedUnusedPoints: '\u5df2\u5206\u914d\u672a\u4f7f\u7528\u9ede\u6578',
          pointsAllocationRecords: '\u9ede\u6578\u5206\u914d\u7d00\u9304',
          time: '\u6642\u9593',
          change: '\u7570\u52d5',
          quantity: '\u6578\u91cf',
          remainingPoints: '\u5269\u9918\u9ede\u6578',
          note: '\u5099\u8a3b',
          increase: '\u589e\u52a0',
          decrease: '\u6e1b\u5c11'
        },
        en: {
          schoolPointsOverview: 'School Points Overview',
          classPointsOverview: 'Class Points Overview',
          pointsAdjustment: 'Points Adjustment',
          personalUsageRecords: 'Personal Usage Records',
          pointsStatusStatistics: 'Points Status Statistics',
          totalPoints: 'Total Points',
          unallocatedPoints: 'Unallocated Points',
          allocatedPoints: 'Allocated Points',
          usedPoints: 'Used Points',
          allocatedUnusedPoints: 'Allocated Unused Points',
          pointsAllocationRecords: 'Points Allocation Records',
          time: 'Time',
          change: 'Change',
          quantity: 'Quantity',
          remainingPoints: 'Remaining Points',
          note: 'Note',
          increase: 'Increase',
          decrease: 'Decrease'
        }
      }
      return copy[this.currentLocale] || copy.tw
    },
    enterprisesId () {
      return this.$store.state.auth.enterpriseId
    },
    groupId () {
      return this.$route.params.groupId
    }
  },
  components: {
    Pagination
  },
  async mounted () {
    await this.getAiSummaryDetail()
    await this.getAiSummary()
  },
  methods: {
    async getAiSummaryDetail () {
      const { data } = await api.get(`enterprises/${this.enterprisesId}/points/detail`)
      this.AiSummaryDetail = data.data
    },
    async getAiSummary () {
      const { data } = await api.get(`enterprises/${this.enterprisesId}/points/logs?page=${this.pageIndex}&pageSize=10`)
      this.AiSummary = data.data
      this.pageCount = data.pageCount
    },
    toPage (toPage) {
      this.pageIndex = toPage
      this.getAiSummary()
    },
    goTitlePage (el) {
      this.title = el
      this.$router.push({ name: el, params:{ groupId: this.groupId}})
    }
  }
}
</script>
<style lang="scss" scoped>
@import "../../../assets/styles/color.scss";
  table {
    border-collapse: collapse;
    width: 100%;
    overflow: auto;
  }
  .pop-box {
    width: 500px !important;
  }
  .menu {
    border-top: 1px solid #ccc;
    border-bottom: 1px solid #ccc;
    .title {
      margin: 10px 30px 10px 0;
    }
  }
  .active {
    // color: red;
    font-weight: bolder;
  }
  th {
    overflow:hidden;
    border: 4px solid #fff;
    color: #fff;
    text-align: center !important;
    padding: 8px;
  }
  tr:nth-child(even){
    background-color:#e8e8e8 !important;
  }
  /*表格中的奇數對 tr*/
  tr:nth-child(odd){
    background-color:#d8d8d8 !important;
  }
  td {
    font-weight: bold;
    // background-color: rgb(230, 230, 230);
    border: 4px solid #fff;
    text-align: center !important;
    padding: 8px;
  }
  .th-title {
    width: 220px;
    height: 120px;
    padding: 0 !important;
    position: relative;
    img {
      top:0;
      left: -5px;
      position: absolute;
      width: 105%;
      height: 100%;
    }
  }
  .title-box {
    margin-bottom: 20px;
    border-top: #aaa solid 1px;
    border-bottom: #aaa solid 1px;
    padding: 10px 0;
    .title {
      color: #aaa;
      margin: 0 50px 0 0;
      cursor: pointer;
    }
    .active {
      color: black;
    }
  }
  .rwd-table {
  margin: auto;
  min-width: 300px;
  max-width: 100%;
  border-collapse: collapse;
}

.rwd-table tr:first-child {
  border-top: none;
  background: $table-gray !important;
  color: #fff;
}

.rwd-table tr {
  border-top: 1px solid #ddd;
  border-bottom: 1px solid #ddd;
  background-color: #f5f9fc;
}

.rwd-table tr:nth-child(odd):not(:first-child) {
  background-color: #ebf3f9;
}

.rwd-table th {
  display: none;
}

.rwd-table td {
  display: block;
}

.rwd-table td:first-child {
  margin-top: .5em;
}

.rwd-table td:last-child {
  margin-bottom: .5em;
}

.rwd-table td:before {
  content: attr(data-th) ": ";
  font-weight: bold;
  width: 120px;
  display: inline-block;
  color: #000;
}

.rwd-table th,
.rwd-table td {
  text-align: left;
}

.rwd-table tr {
  border-color: #bfbfbf;
}

.rwd-table th,
.rwd-table td {
  padding: .5em 1em;
}
@media screen and (max-width: 601px) {
  .rwd-table tr:nth-child(2) {
    border-top: none;
  }
  .rwd-td {
    display: block !important;
    background-color: #04a2d6;
  }
  td {
    border: 1px solid #ccc;
  }
  button  {
    display: none;
  }
}
.lesson-box {
  width: 80%;
}
.group-box {
  width: 20%;
}
.box {
  margin: 5px;
  padding: 10px;
  background-color: #044ed6;
  color: #fff;
}
@media screen and (min-width: 600px) {
  .rwd-table tr:hover:not(:first-child) {
    background-color: #d8e7f3;
  }
  .rwd-table td:before {
    display: none;
  }
  .rwd-table th,
  .rwd-table td {
    display: table-cell;
    padding: .25em .5em;
  }
  .rwd-table th:first-child,
  .rwd-table td:first-child {
    padding-left: 0;
  }
  .rwd-table th:last-child,
  .rwd-table td:last-child {
    padding-right: 0;
  }
  .rwd-table th,
  .rwd-table td {
    // padding: 1em !important;
  }
}
</style>
